import { useRef, useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useRegisterMutation } from "./authApiSlice";
import { Callout } from "@tremor/react";
import Reset from "./Reset";
// import LandingHeader from "../../components/LandingHeader";
// import LandingFooter from "../../components/LandingFooter";
import { useSelector, useDispatch } from "react-redux";
import {
  setmodalTrigger,
  selectmodalTrigger,
} from "../../components/TransitionSlice";
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline";
import { useLoginMutation } from "./authApiSlice";
import { setCredentials } from "./authSlice";

const Register = ({ showModalRegister, closeModalRegister }) => {
  const modalRef = useRef(null); // Create a reference for the modal container
  const [register, { isLoading, isSuccess, isError, error }] =
    useRegisterMutation();
  const navigate = useNavigate();
  const errRef = useRef();
  const [errMsg, setErrMsg] = useState("");

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordAgain, setPasswordAgain] = useState("");
  const [warning, setWarning] = useState("");
  const [mailProvera, setMailProvera] = useState(true);
  const [uloguj, setUloguj] = useState(false);
  const [registruj, setRegistruj] = useState(false);
  const [showModalResetEmail, setShowModalResetEmail] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false); // Za popup uspesna registracija
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => {
    setIsModalOpen(false);
    closeModalRegister();
  };

  const [login] = useLoginMutation();

  const errClass = errMsg ? "errmsg" : "offscreen";

  //Za Register to login
  const dispatch = useDispatch();
  const modalTrigger = useSelector(selectmodalTrigger);

  const [termsAndCond, setTermsAndCond] = useState(false);

  useEffect(() => {
    const storedCheckboxState = localStorage.getItem("termsAndCond");
    if (storedCheckboxState) {
      setTermsAndCond(JSON.parse(storedCheckboxState));
    }
  }, []);

  const handleTermsAndCond = (event) => {
    const checked = event.target.checked;
    setTermsAndCond(checked);

    localStorage.setItem("termsAndCond", JSON.stringify(checked));
  };

  // Handle clicks outside the modal to close it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        closeModalRegister();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [closeModalRegister]);

  //Za oko
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const togglePasswordVisibility = () => {
    setIsPasswordVisible((prev) => !prev);
  };

  useEffect(() => {
    if (isSuccess) {
      setPassword("");
      setPasswordAgain("");
      setEmail("");
      // alert("Uspešno ste se registrovali, proverite Vaš mail za aktivaciju!");
      // console.log("Success, opening modal...");
      openModal(); //Nece da otvori modal

      // dispatch(setmodalTrigger(!modalTrigger));
      // navigate("/login"); //Stavi da se updejtuje u redux neki state za uspesno
      // jovanovicv420@gmail.com
    }
  }, [isSuccess, navigate]);

  if (!showModalRegister) return null;

  const onEmailChanged = (e) => setEmail(e.target.value);
  const onPasswordChanged = (e) => setPassword(e.target.value);
  const onPasswordAgainChanged = (e) => setPasswordAgain(e.target.value);

  // work here 1
  const onSaveUserClicked = async (e) => {
    e.preventDefault();

    const isOnlySpaces = (val) =>
      typeof val === "string" && val.trim() === "" && val.length > 0;

    if (isOnlySpaces(email)) {
      setErrMsg("Polje za email je obavezno");
      errRef.current.style = "display:block";
      errRef.current.focus();
      return;
    }

    if (isOnlySpaces(password)) {
      setErrMsg("Polje za lozinku je obavezno");
      errRef.current.style = "display:block";
      errRef.current.focus();
      return;
    }

    if (isOnlySpaces(passwordAgain)) {
      setErrMsg("Polje za ponovljenu lozinku je obavezno");
      errRef.current.style = "display:block";
      errRef.current.focus();
      return;
    }

    if (password !== passwordAgain) {
      setErrMsg("Lozinke moraju da se poklapaju!");
      errRef.current.style = "display:block";
      errRef.current.focus();
      return;
    }

    if (!password || !email) {
      setErrMsg("Uneti podatke");
      errRef.current.style = "display:block";
      errRef.current.focus();
      return;
    }

    try {
      let response = await register({ email, password }).unwrap();
      if (response?.error?.status === 409) {
        setErrMsg(response.error.data.message);
        errRef.current.style = "display:block";
        errRef.current.focus();
      }
    } catch (err) {
      setErrMsg(err.data?.message);
      errRef.current.style = "display:block";
      errRef.current.focus();
    }
  };

  if (!showModalRegister) return null;

  //Za monkey sign
  const handleUserInputEmail = (e) => {
    setEmail(e.target.value);
  };

  //Google
  const handleGoogleLogin = () => {
    window.open(`${process.env.REACT_APP_API_URL}/auth/google`, "_self"); // Backend Google ruta
  };

  //Provera maila - work here
  const proveriMail = async () => {
    const isOnlySpaces = (val) =>
      typeof val === "string" && val.trim() === "" && val.length > 0;

    if (isOnlySpaces(email)) {
      setErrMsg("Ovo polje je obavezno");
      errRef.current.style = "display:block";
      errRef.current.focus();
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/proveraEmaila`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email }),
        }
      );

      const result = await response.json();

      // console.log("result => ", result);

      if (result.error == "Nemate nalog, mozete ga napraviti.") {
        setMailProvera(false);
        setRegistruj(true);
        setWarning("");
      }
      if (result.message == "Posedujete nalog, mozete se ulogovati!") {
        setMailProvera(false);
        setUloguj(true);
        setWarning("");
      }
      if (result.error == "Molim vas unesite validnu email adresu.") {
        // setWarning(result.error);
        errRef.current.style = "display:block";
        setErrMsg(result.error);
        // console.log(result.error);
      }
      if (result.error == "Uneti podatke") {
        // setWarning(result.error);
        errRef.current.style = "display:block";
        setErrMsg(result.error);
        // console.log(result.error);
      }
      if (result.error == "Doslo je do greske na serveru!") {
        // setWarning(result.error);
        errRef.current.style = "display:block";
        setErrMsg(result.error);
        // console.log(result.error);
      }
    } catch (error) {
      console.error("Greska prilikom provere email-a:", error);
      alert("Došlo je do greške na serveru.");
    }
  };

  const logIn = async (e) => {
    e.preventDefault();
    try {
      let email_ = email.toLowerCase();
      const { accessToken } = await login({ email: email_, password }).unwrap();
      dispatch(setCredentials({ accessToken }));
      setEmail("");
      setPassword("");
      localStorage.setItem("persist", JSON.stringify(true)); //Postavlja persist true kad se uloguje da ne bi se izlovao
      navigate("/dash");
    } catch (err) {
      let errorMessage = "Neka greška je nastala";
      if (!err.status) {
        errorMessage = "Nema odgovora od servera!";
      } else if (err.status === 400) {
        errorMessage = "Sva polja su potrebna";
      } else if (err.status === 401) {
        if (err.data?.message === "Nepostojeći korisnik") {
          errorMessage = "Korisnik ne postoji";
        } else if (err.data?.message === "Pogrešna lozinka") {
          errorMessage = "Pogrešna lozinka";
        } else {
          errorMessage = "Neautorizovano";
        }
      } else {
        errorMessage = err.data?.message || "Neka greška je nastala";
      }

      setErrMsg(errorMessage);
      errRef.current.style = "display:block";
      errRef.current.focus();
    }
  };

  //Kad se klikne enter onda se loginuje
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      proveriMail(); //
    }
  };

  //Za reset mail modal
  const openModalResetMail = () => {
    setShowModalResetEmail(true);
  };

  const closeModalResetEmail = () => setShowModalResetEmail(false);

  const handleOverlayClick = (e) => {
    if (e.target.id === "modal-overlay") {
      closeModalResetEmail();
    }
  };

  let proveraBtn = (
    <div className="flex justify-end">
      <button
        onClick={proveriMail}
        className="rounded-full"
        style={{
          backgroundColor: "#22bd5d", //Zeleno
          width: "50px",
          height: "50px",
          color: "white",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
          transition: "background-color 0.2s",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <svg
          className="h-10 w-10"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
          data-slot="icon"
        >
          <path
            d="M5 10h10M10 5l5 5-5 5"
            stroke="currentColor"
            strokeWidth="1"
            fill="none"
          />
        </svg>
      </button>
    </div>
  );

  let signInButton = (
    <div className="flex justify-end">
      <button
        onClick={onSaveUserClicked}
        className="rounded-full"
        disabled={!termsAndCond}
        style={{
          backgroundColor: "#09db59", //Zuto
          width: "50px",
          height: "50px",
          color: "white",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
          transition: "background-color 0.2s",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: termsAndCond ? "pointer" : "not-allowed",
        }}
      >
        <svg
          className="h-10 w-10"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
          data-slot="icon"
        >
          <path
            d="M5 10h10M10 5l5 5-5 5"
            stroke="currentColor"
            strokeWidth="1"
            fill="none"
          />
        </svg>
      </button>
    </div>
  );

  let logInButton = (
    <div className="flex justify-end">
      <button
        onClick={logIn}
        className="rounded-full"
        style={{
          backgroundColor: "#1FDC27", //Zeleno
          width: "50px",
          height: "50px",
          color: "white",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
          transition: "background-color 0.2s",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <svg
          className="h-10 w-10"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
          data-slot="icon"
        >
          <path
            d="M5 10h10M10 5l5 5-5 5"
            stroke="currentColor"
            strokeWidth="1"
            fill="none"
          />
        </svg>
      </button>
    </div>
  );

  const tailwindRegister = (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="h-[90vh] md:h-[80vh] overflow-y-auto" ref={modalRef}>
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          {/* <Callout
            ref={errRef}
            className={errClass}
            color="red"
            style={{ display: "none" }}
          >
            {errMsg}
          </Callout> */}
        </div>

        <div className="mt-2 sm:mx-auto sm:w-full sm:max-w-[480px] border-4 border-[#66BB6A] rounded-3xl p-4 bg-white">
          <div
            className={`bg-white px-3 py-6 shadow rounded-3xl sm:px-6 border-4 ${
              uloguj ? "border-[#DCC72A]" : "border-[#615c5c]"
            }`}
          >
            <Callout
              ref={errRef}
              className={errClass}
              color="red-800"
              style={{ display: "none" }}
            >
              {errMsg}
            </Callout>

            {/* work here */}
            <div className="space-y-6">
              <div className="relative">
                <button
                  onClick={closeModalRegister}
                  className="absolute top-0 right-0 text-black hover:text-gray-700 text-sm"
                  aria-label="Close"
                >
                  ✘
                </button>
              </div>

              <h2
                className="mt-1 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900"
                style={{ marginTop: "0px" }}
              >
                {mailProvera && "Registracija novog korisnika"}
                {uloguj && "Log in"}
                {registruj && "Registracija profila"}
              </h2>
              <div>
                <label
                  htmlFor="email"
                  className="block text-sm font-medium leading-6 text-gray-900"
                >
                  Email
                </label>

                <div className="flex items-center space-x-2 mt-1">
                  <div className="flex-1 max-w-xs">
                    <input
                      type="text"
                      id="username"
                      value={email}
                      onChange={handleUserInputEmail}
                      onKeyDown={handleKeyDown}
                      autoComplete="off"
                      className={`block ${
                        mailProvera ? "w-full" : "w-96"
                      } block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6`}
                      required
                    />
                  </div>
                  {mailProvera && proveraBtn}
                </div>

                {warning && (
                  <p className="mt-2 text-sm text-red-600">{warning}</p>
                )}
              </div>

              {/* <div>
                <label
                  htmlFor="password"
                  className="block text-sm font-medium leading-6 text-gray-900"
                >
                  Lozinka
                </label>
                <div className="mt-2">
                  <input
                    type="text"
                    id="password"
                    value={password}
                    onChange={onPasswordChanged}
                    autoComplete="off"
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                    required
                  />
                </div>
              </div> */}

              {registruj || uloguj ? (
                <>
                  <div>
                    <label
                      htmlFor="password"
                      className="block text-sm font-medium leading-6 text-gray-900"
                    >
                      {registruj ? "Kreiraj lozinku" : "Password"}
                    </label>
                    <div className="mt-1 relative">
                      <input
                        type={isPasswordVisible ? "text" : "password"} // Toggle input type
                        id="password"
                        value={password}
                        onChange={onPasswordChanged}
                        autoComplete="off"
                        className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                        required
                      />
                      <button
                        type="button"
                        onClick={togglePasswordVisibility}
                        className="absolute inset-y-0 right-0 flex items-center pr-3"
                      >
                        {isPasswordVisible ? (
                          <EyeSlashIcon
                            className="h-5 w-5 text-gray-400"
                            aria-hidden="true"
                          />
                        ) : (
                          <EyeIcon
                            className="h-5 w-5 text-gray-400"
                            aria-hidden="true"
                          />
                        )}
                      </button>
                    </div>
                    {/* {uloguj && (
                      <div className="inline-flex items-center justify-between px-6 py-4 bg-gray-50 rounded-lg shadow-md w-auto">
                        <div className="flex items-center">
                          <label
                            htmlFor="remember-me"
                            className="text-sm font-medium text-gray-700 mr-3"
                          >
                            <button
                              // to="/email"
                              onClick={openModalResetMail}
                              className="text-blue-500 hover:text-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            >
                              Zaboravljena lozinka?
                            </button>
                          </label>
                        </div>
                      </div>
                      )}*/}
                    {uloguj && (
                      <>
                        <br />
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            flexDirection: "column",
                            width: "100%",
                            marginTop: "1%",
                          }}
                        >
                          <div className="inline-flex items-center justify-between px-6 py-4 bg-gray-50 rounded-lg shadow-md w-auto">
                            <div className="flex items-center">
                              <label
                                htmlFor="remember-me"
                                className="text-sm font-medium text-gray-700 mr-3"
                              >
                                <button
                                  // to="/email"
                                  onClick={openModalResetMail}
                                  className="text-blue-500 hover:text-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                >
                                  Zaboravljena lozinka?
                                </button>
                              </label>
                            </div>
                          </div>

                          <br />

                          <label style={{ fontWeight: "bold", color: "black" }}>
                            Prijava putem Google-a
                          </label>

                          <button
                            onClick={handleGoogleLogin}
                            className="flex items-center bg-white text-black py-2 px-4 border border-black rounded-lg cursor-pointer font-medium text-base justify-center w-auto max-w-full mt-2"
                          >
                            <img
                              src={`${process.env.PUBLIC_URL}/img/g1.png`}
                              alt="Google logo"
                              className="w-5 h-5 mr-2"
                            />
                            <span>Google</span>
                          </button>
                        </div>
                      </>
                    )}
                  </div>

                  {registruj ? (
                    <>
                      <div>
                        <label
                          htmlFor="passwordAgain"
                          className="block text-sm font-medium leading-6 text-gray-900"
                        >
                          Ponovi lozinku
                        </label>
                        <div className="mt-2 relative">
                          <input
                            type={isPasswordVisible ? "text" : "password"} // Toggle input type
                            id="passwordAgain"
                            value={passwordAgain}
                            onChange={onPasswordAgainChanged}
                            autoComplete="off"
                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                            required
                          />
                          <button
                            type="button"
                            onClick={togglePasswordVisibility}
                            className="absolute inset-y-0 right-0 flex items-center pr-3"
                          >
                            {isPasswordVisible ? (
                              <EyeSlashIcon
                                className="h-5 w-5 text-gray-400"
                                aria-hidden="true"
                              />
                            ) : (
                              <EyeIcon
                                className="h-5 w-5 text-gray-400"
                                aria-hidden="true"
                              />
                            )}
                          </button>
                        </div>
                      </div>
                      <br />
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          flexDirection: "column",
                          width: "100%",
                          marginTop: "1%",
                        }}
                      >
                        <label style={{ fontWeight: "bold" }}>
                          Registracija putem Google-a
                        </label>
                        <br />

                        <button
                          onClick={handleGoogleLogin}
                          className="flex items-center bg-white text-black py-2 px-4 border border-black rounded-lg cursor-pointer font-medium text-base justify-center w-auto max-w-full"
                        >
                          <img
                            src={`${process.env.PUBLIC_URL}/img/g1.png`}
                            alt="Google logo"
                            className="w-5 h-5 mr-2"
                          />
                          <span>Google</span>
                        </button>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </>
              ) : (
                ""
              )}

              {/* work here */}
              {mailProvera && (
                <>
                  <br />
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      flexDirection: "column",
                      width: "100%",
                      marginTop: "1%",
                    }}
                  >
                    <label style={{ fontWeight: "bold", color: "black" }}>
                      Registracija putem Google-a!
                    </label>

                    <button
                      onClick={handleGoogleLogin}
                      style={{ marginTop: "13px" }}
                      className="flex items-center bg-white text-black py-2 px-4 border border-black rounded-lg cursor-pointer font-medium text-base justify-center w-auto max-w-full"
                    >
                      <img
                        src={`${process.env.PUBLIC_URL}/img/g1.png`}
                        alt="Google logo"
                        className="w-5 h-5 mr-2"
                      />
                      <span>Google</span>
                    </button>
                  </div>
                </>
              )}

              {/* Button here  */}

              {registruj && (
                <div className="flex items-center justify-between">
                  <div className="flex items-center">
                    <input
                      type="checkbox"
                      className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-600"
                      id="uslovi"
                      onChange={handleTermsAndCond}
                      checked={termsAndCond}
                    />
                    <label
                      htmlFor="remember-me"
                      className="ml-3 block text-sm leading-6 text-gray-900"
                    >
                      Da bi ste nastavili, morate prihvatiti NutriTrans{" "}
                      <a
                        href="/terms"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-500 underline ml-1"
                      >
                        uslove korišćenja usluge
                      </a>
                      .
                    </label>
                  </div>
                </div>
              )}

              {uloguj && logInButton}
              {registruj && signInButton}
              {/* Modal za Reset loznike */}
              {showModalResetEmail && (
                <div
                  id="modal-overlay"
                  className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center"
                  onClick={handleOverlayClick}
                >
                  {/* <div onClick={(e) => e.stopPropagation()} className="bg-white rounded-lg p-4"> */}
                  <Reset
                    showModalResetEmail={showModalResetEmail}
                    closeModalResetEmail={closeModalResetEmail}
                  />
                  {/* </div> */}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <>
      {/* <LandingHeader /> */}
      {tailwindRegister}
      {/* <LandingFooter /> */}

      {isModalOpen && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center">
          <div className="relative p-5 border w-96 shadow-lg rounded bg-white">
            <div className="mt-3 text-center">
              <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100">
                <svg
                  className="h-6 w-6 text-yellow-600"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                  />
                </svg>
              </div>
              <h3 className="text-lg leading-6 font-medium text-gray-900 mt-5">
                Čestitamo na kreiranju Vašeg profila!
              </h3>
              <div className="mt-2 px-7 py-3">
                <p className="text-sm text-gray-500">
                  Uspešno ste registrovali Vaš nalog! Molim Vas proverite email
                  adresu da bi ste verifikovali Vaš NutriTrans nalog!
                </p>
              </div>
              <div className="items-center px-4 py-3">
                <button
                  onClick={closeModal}
                  className="mt-3 px-4 py-2 bg-white text-gray-800 text-base font-medium rounded w-full shadow-sm border border-gray-300 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-300"
                >
                  U redu
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Register;
